import React, { useRef } from 'react'
import useStyles from './Styles'
import { IProps } from './Interface'
import { Box } from '@material-ui/core'
import { FreeText } from 'components'
import { LabelPosition } from 'types'
import { useOutsideClick } from 'utils'
import handleEnterKey from 'utils/handle-enter-key'

const ParagraphQuestion: React.FC<IProps> = ({ edit, questions, onSave, onChange, onClickOutside, ...props }) => {
  const disabled = !edit && questions.every(questions => questions.initialValue)
  const classes = useStyles({ disabled })

  const ref = useRef()

  useOutsideClick(ref, () => {
    if (edit) {
      onClickOutside()
    }
  })

  return (
    <Box className={classes.root} ref={ref} {...props}>
      {questions.map(({ questionKey, label, initialValue }, index) => (
        <Box key={questionKey} mb={1}>
          <FreeText
            id={`${index}-${questionKey}`}
            label={label}
            limit={85}
            textSize={20}
            showLimit={true}
            disabled={disabled}
            initialValue={initialValue}
            labelPosition={LabelPosition.Left}
            autoFocus={index === 0}
            onSave={value => onSave({ response: value, questionKey })}
            onKeyPress={handleEnterKey((value: any) => {
              onSave({ response: value, questionKey })
              if (questions.length === index + 1) onClickOutside(true)
            })}
            onChange={value => onChange({ response: value, questionKey })}
            classNames={{
              root: classes.freeTextRoot,
              labelContainer: classes.labelContainer,
              inputContainer: classes.inputContainer
            }}
          />
        </Box>
      ))}
      {disabled && '.'}
    </Box>
  )
}

ParagraphQuestion.defaultProps = {
  edit: false,
  questions: [],
  onSave: () => {},
  onClickOutside: () => {}
}

export default ParagraphQuestion
